import AppBarUser from "../../components/AppBarUser";
import CustomDivider from "../../components/CustomDivider";
import Formulario from "../../components/Formulario";

export default function EdicaoSolicitante() {
    return(
        <>
            <AppBarUser title="Editar solicitação" />
            <CustomDivider /> 
            <Formulario />
        </>
    )
}